import React, {useContext, useEffect, useState} from "react";
import moment from "moment";
import BackgroundTaskIcon from "../../icons/BackgroundTaskIcon";
import LoaderCircle from "../../loader/LoaderCircle";
import ATask from "./ATask";
import CancelIcon from "../../icons/CancelIcon";
import BackofficeContext from "../../../context/BackofficeContext";
import "../../../css/page/BackgroundTasks.css";
import "moment/locale/fr";
moment.locale("fr");

const BackgroundTasks = () => {
    const { backgroundTasks, typeDeployProcess } = useContext(BackofficeContext);
    const [ tasksList, setTasksList ] = useState([]);
    const [ extendState, setExtendState ] = useState(false);
    const [ stateIcon, setStateIcon ] = useState(null);

    const extend = () => {
        setExtendState(!extendState);
    }
    const close = () => {
        setExtendState(false);
    }
    const checkTasks = () => {
        if (backgroundTasks === null)
            return;

        const resultLoading = backgroundTasks.find(_ => _.inProgress.length > 0 || _.state === true) !== undefined;
        const resultWaiting = analyzeAvailables();
        const resultIssued = backgroundTasks.find(_ => _.issued.length > 0) !== undefined;
        const resultPlanned = backgroundTasks.find(_ => _.planned.length > 0) !== undefined;
        const resultFinished = backgroundTasks.find(_ => _.finished.length > 0) !== undefined;

        if (resultLoading) setStateIcon("loading");
        else if (resultWaiting) setStateIcon("waiting");
        else if (resultIssued) setStateIcon("issued");
        else if (resultPlanned ||resultFinished) setStateIcon("finished");

        let task;
        let tasksListTmp = [];

        for (let i in backgroundTasks) {
            task = backgroundTasks[i];

            if (task.state)
                tasksListTmp.push(task);
            else if (
                task.asked.length > 0
                || analyzeAvailables(task)
                || task.finished.length > 0
                || task.inProgress.length > 0
                || task.planned.length > 0
                || task.issued.length > 0
            )
                tasksListTmp.push(task);
        }

        setTasksList(tasksListTmp);
    }
    const analyzeAvailables = (target = null) => {
        if (target === null) {
            for (let i in backgroundTasks) {
                if (checkAvailableForTask(backgroundTasks[i]))
                    return true;
            }
        }
        else {
            if (checkAvailableForTask(target))
                return true;
        }

        return false;
    }
    const checkAvailableForTask = backgroundTask => {
        const keys = Object.keys(backgroundTask.available);

        switch (backgroundTask.type) {
            case "catalogDeployments":
                for (let j in keys) {
                    if (backgroundTask.available[keys[j]].hasUpdates)
                        return true;
                }

                break;
            case "settingDeployments":
                if (keys.length > 0 && keys[0] === "posscreens") {
                    const internalKeys = Object.keys(backgroundTask.available["posscreens"]);

                    for (let j in internalKeys) {
                        if (backgroundTask.available["posscreens"][internalKeys[j]].hasUpdates)
                            return true;
                    }
                }

                break;
            default: break;
        }
    }

    useEffect(() => {
        checkTasks();
    }, [backgroundTasks]);
    useEffect(() => {
        if (typeDeployProcess !== null)
            close();
    }, [typeDeployProcess]);

    return (
        stateIcon !== null
        && <>
            <div id={"iconBackgroundTask"} className={"iconBackgroundTask"} onClick={extend}>
                <BackgroundTaskIcon />
                {
                    stateIcon === "loading"
                        ? <div className={"containerLoading"}><LoaderCircle display="loading" stroke={"#FFFFFF"} strokeWidth="8" /></div>
                        : ["waiting", "finished", "issued"].includes(stateIcon) && <div className={stateIcon} />
                }
            </div>
            <div id={"backgroundTasks"} className={"backgroundTasks" + (extendState ? " opened" : "")}>
                <div className={"containerTitle"}>
                    <p className={"title"}>Opérations en cours</p>
                    <CancelIcon classname={"close"} click={extend} />
                </div>
                <nav className={"list"}>
                    { tasksList.map((task, index) => <ATask key={index} task={task} />) }
                </nav>
            </div>
        </>
    );
}

export default BackgroundTasks;